export default {
	type: 'object',
	properties: {
		projectUrl: { type: 'string' },
		message: {
			type: 'string',
			maxLength: 300,
			errorMessage: {
				maxLength: '300 characters max.',
			},
		},
	},
	required: ['projectUrl'],
	additionalProperties: false,
}
